<template>
  <div>
    <div class="text-no-wrap text-truncate">
      <v-icon small left>mdi-account-outline</v-icon>
      {{ contactName }}
    </div>
    <div class="text-no-wrap text-truncate">
      <v-icon small left>mdi-phone-outline</v-icon>
      {{ msg.callerNum | formatPhoneNum(countryCode) }}
    </div>
    <div class="text-no-wrap text-truncate">
      <v-icon small left>mdi-calendar-today</v-icon>
      {{ msg.time | formatDateLong($i18n.locale) }}
    </div>
    <div class="text-no-wrap text-truncate">
      <v-icon small left>mdi-clock-outline</v-icon>
      {{ msg.duration | formatTime }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'voicemail-msg-info',
  props: {
    msg: {
      type: Object
    }
  },
  computed: {
    ...mapGetters({
      countryCode: 'countryCode',
      phoneNumbers: 'contacts/phoneNumbers/phoneNumbers'
    }),
    contact () {
      return this.phoneNumbers?.find((phone) => parseInt(phone.phoneNumber) === parseInt(this.msg?.callerNum))
    },
    contactName () {
      return this.contact ? this.contact.name : this.msg?.callerName
    }
  }
}
</script>

<style scoped>
</style>
